module.exports = __webpack_public_path__ + "img/gb.b518e6a9.svg";